import { render, staticRenderFns } from "./certificationExaminer.vue?vue&type=template&id=370f24ed&scoped=true&"
import script from "./certificationExaminer.vue?vue&type=script&lang=js&"
export * from "./certificationExaminer.vue?vue&type=script&lang=js&"
import style0 from "./certificationExaminer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./certificationExaminer.vue?vue&type=style&index=1&id=370f24ed&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370f24ed",
  null
  
)

export default component.exports